import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//data inicial
const dataInicial = {
    data: {},
    fc_34: {
        tipoinstalacion: '',
        responsableinstalaciones: '',
        correoelectronico: '',
        telefono: '',
        domicilio: '',
        produccionsuspencion: false,
        produccionreactivacion: false,
        certificadonomproductor: false,
        envasadosuspencion: false,
        envasadoreactivacion: false,
        certificadonomcomercializador: false,
        motivosuspencion: '',
        fechacortecosecha: fechaHoy,
        fechainicioproduccion: fechaHoy,
        especiesagaveutilizado: '',
        fechaterminoproduccion: fechaHoy,
        numerolote: '',
        kgagave: '',
        fechamuestreo: fechaHoy,
        informacionadicional: '',
    },
    loading: false,
    modoEdicionBorrador: false,
    paginaActiva: 1,
    fc_34Map: {},
    modoCorreccion: false,
    cliente: [],
    instalacionesCliente: [],
    dataLogin: [],
    instalaciones:[],
}

//types
const FC_34_SOLICITUD_EXITO = 'FC_34_SOLICITUD_EXITO'
const AGREGAR_FC_34_BORRADOR_EXITO = 'AGREGAR_FC_34_BORRADOR_EXITO'
const OBTENER_FC_34_DETALLE_EXITO = 'OBTENER_FC_34_DETALLE_EXITO'
const ACTUALIZAR_FC_34_ESTATUS_EXITO = 'ACTUALIZAR_FC_34_ESTATUS_EXITO'
const ELIMINAR_FC_34_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_34_SOLICITUD_EXITO_BD'
const OBTENER_FC_34_MAP_EXITO = 'OBTENER_FC_34_MAP_EXITO'
const OBTENER_FC_34_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_34_CONTADOR_FECHA_FOLIO_EXITO'
const OBTENER_CLIENTE_POR_LOGIN_EXITO_34 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO_34'
const ACTUALIZAR_FC_34_EXITO = 'ACTUALIZAR_FC_34_EXITO'

export const registrarSolicitudFC_34Accion = createAsyncThunk(
    FC_34_SOLICITUD_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_34/agregarFormatoFC34`
            const res = await axios.post(fullUrl, { data })
            return { data: res.data.data }
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_34_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)
export const ObtenerClientePorLogin34 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO_34,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`

            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            let idcartera = res.data.data.idcartera
            const fullUrlInstalaciones = host + `InformacionValida/obtenerTodosAnexosCliente/${idcliente}`
            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            const fullUrlDomicilioCliente = host + `InformacionValida/obtenerDomicilioFiscalClientePorCliente/${idcliente}`

            const resinstalaciones = await axios.get(fullUrlInstalaciones)
            const resdomicilio = await axios.get(fullUrlDomicilioCliente)
            let datos = []
            let instalaciones = []
            //let dat = []
            //dat.push(resdomicilio.data.data)
            //let onjUnidos = Object.assign(resinstalaciones.data.data, dat)
            instalaciones.push(resinstalaciones.data.data)
            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)
            datos.push(res.data.data, instalaciones, datosLogin)
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_34Estatus = createAsyncThunk(
    ACTUALIZAR_FC_34_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_34Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_34_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_34/actualizarFormatoFC34`
            const res = await axios.put(fullUrl, { data:data })
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerFC_34SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_34_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_34/obtenerFormatoFC34/${idSolicitud}`
            const res = await axios.get(fullUrl)
            console.log("la res ", res.data.data[0])
            if (res.data.data?.[0].fechacortecosecha) res.data.data[0].fechacortecosecha = moment(res.data.data[0].fechacortecosecha).add(1, 'd').format('YYYY-MM-DD')
            if (res.data.data?.[0].fechainicioproduccion) res.data.data[0].fechainicioproduccion = moment(res.data.data[0].fechainicioproduccion).add(1, 'd').format('YYYY-MM-DD')
            if (res.data.data?.[0].fechaterminoproduccion) res.data.data[0].fechaterminoproduccion = moment(res.data.data[0].fechaterminoproduccion).add(1, 'd').format('YYYY-MM-DD')
            if (res.data.data?.[0].fechamuestreo) res.data.data[0].fechamuestreo = moment(res.data.data[0].fechamuestreo).add(1, 'd').format('YYYY-MM-DD')

            const fullUrlLogin = host + `InformacionValida/obtenerClientePorLogin/${res?.data?.data?.[0]?.idlogin}`
            const resLogin = await axios.get(fullUrlLogin)
            let idcliente = resLogin.data.data.idcliente
            const fullUrlInstalaciones = host + `InformacionValida/obtenerTodosAnexosCliente/${idcliente}`
            const resinstalaciones = await axios.get(fullUrlInstalaciones)
            console.log("res instalaciones ", resinstalaciones)
            let filtro = []
            if(res.data?.data?.[0]?.servicioinstalacion=='produccion'){
                filtro = resinstalaciones.data?.data?.filter(anexo=>anexo.idtipoanexo==1)
            }
            if(res.data?.data?.[0]?.servicioinstalacion=='envasado'){
                filtro = resinstalaciones.data?.data?.filter(anexo=>anexo.idtipoanexo==2)
            }
            if(res.data?.data?.[0]?.servicioinstalacion=='almacen'){
                filtro = resinstalaciones.data?.data?.filter(anexo=>anexo.idtipoanexo==3)
            }

            let datos ={res:res.data.data, resinstalaciones:filtro}

            return datos
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarFC_34SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_34_SOLICITUD_EXITO_BD,
    async (id) => {
        try {
            const fullUrlSolicitud = host + `FC_34/eliminarFormatoFC34/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return { id }
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerFC_34Map = createAsyncThunk(
    OBTENER_FC_34_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_34_NotificacionSuspencionYReactivacionMap/${solicitudId}`
            const res = await axios.get(fullUrl)
            if (res != null) {
                return res.data.data
            } else {
                return {}
            }
        } catch (error) {
            console.log(error)
        }
    }
)

export const agregarFC_34SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_34_BORRADOR_EXITO,
    async (data) => {
        try {
            const fullUrl = host + `FC_34/agregarFormatoFC34`
            const res = await axios.post(fullUrl, { data })
            return data
        } catch (error) {
            console.log(error)
        }
    }
)

export const fc34Slice = createSlice({
    name: 'fc34Slice',
    initialState: dataInicial,
    reducers: {
        guardarCambiosFC_34SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        agregarInstalaciones(state, { payload }) {
            state.instalaciones = payload
        },
        guardarCambiosFC_34SolicitudNueva(state, { payload }) {
            state.fc_34 = payload
        },
        actualizarModoBorradorFC_34(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarFC_34PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        resetDataFC_34(state, { payload }) {
            return dataInicial
        },
        setModoCorrecionFC_34(state, { payload }) {
            state.modoCorreccion = payload
        }
    },
    extraReducers: {
        [ObtenerClientePorLogin34.fulfilled]: (state, { payload }) => {
            state.cliente = payload[0]
            state.instalacionesCliente = payload[1][0]
            state.dataLogin = payload[2][0][0]
        },
        [agregarFC_34SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [registrarSolicitudFC_34Accion.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_34Estatus.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_34SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload.res[0]
            state.fc_34 = payload.res[0]
            state.instalaciones = payload.resinstalaciones
        },
        [eliminarFC_34SolicitudBD.fulfilled]: (state, { payload }) => {
        },
        [obtenerFC_34Map.fulfilled]: (state, { payload }) => {
            state.fc_34Map = payload
        }
    },
})

//actions
export const {
    actualizarModoBorradorFC_34, actualizarFC_34PaginaActiva,
    guardarCambiosFC_34SolicitudBorrador, guardarCambiosFC_34SolicitudNueva,
    resetDataFC_34, setModoCorrecionFC_34, agregarInstalaciones
} = fc34Slice.actions

export const FC34ReducerBeneficiario = fc34Slice.reducer
